import { csrfToken } from "@circle-react/helpers/csrfToken";
import Cookies from "js-cookie";

export const showRecaptcha = (env: any) =>
  ["production", "staging"].includes(env);

export const turnstileEnabled = (env: any) =>
  ["production", "staging", "development"].includes(env);

export const getCsrfToken = () => csrfToken() ?? "";

const COOKIEYES_CONSENT_COOKIE = "cookieyes-consent";

export const skipRecaptchaByCookieYesConsent = (): boolean => {
  const raw = Cookies.get(COOKIEYES_CONSENT_COOKIE);
  if (raw == null || raw === "") return false;

  return raw.includes("consent:no") || raw.includes("advertisement:no");
};
